import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { size } from "lodash";

function Customers() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>

			<Helmet>
				<title>Find Reliable Customers for Your Business on TaskFlier - Join Today! </title>
			</Helmet>

			<div class="pricing-section-one  md-mb-80 bg-gray">
				<div class="fancy-hero-one">
					<div class="container">
						<div class="row">
							<div class="col-xl-8 col-lg-8 m-auto">
								<h2 class="font-rubik plantitle">Examine the reviews of TaskFliers to understand how we have assisted our clients in enhancing their project success.</h2>
							</div>
						</div>

					</div>
					<div class="bubble-one"></div>
					<div class="bubble-two"></div>
					<div class="bubble-three"></div>
					<div class="bubble-four"></div>
					<div class="bubble-five"></div>
					<div class="bubble-six"></div>
				</div>
				<div class="pricing-table-area pb-80">

					<div class="container">
						<div class="row">
							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
								<div class="team-member team-block-one mb-20" >

									<div class="img-meta"><img src="/main/images/customer/team1.jpg" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- Anand Kumar</div>
										<div class="desig font-16 themecolor">"TaskFlier has greatly improved our team's performance tracking and goal setting. Driving success in direct sales."</div>

									</div>
								</div>
							</div>

							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
								<div class="team-member team-block-one mb-20" >

									<div class="img-meta"><img src="/main/images/customer/team2.jpg" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- M.I. Ahmed</div>
										<div class="desig font-16 themecolor">"TaskFlier makes it easy to manage inventory and services, keeping supermarket operations organized and running smoothly."</div>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
								<div class="team-member team-block-one mb-20" >

									<div class="img-meta"><img src="/main/images/customer/team3.jpg" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- Shyam  Yadav</div>
										<div class="desig font-16 themecolor">"TaskFlier monitors customer preferences and prices. Make your accounts more organized and less stressful."</div>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
								<div class="team-member team-block-one mb-20" >

									<div class="img-meta"><img src="/main/images/customer/team4.jpg" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- Vineet Goyal</div>
										<div class="desig font-16 themecolor">"Excellent tool for managing budgets and financial accountability in projects."</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="fancy-feature-ten  bg-gray " id="feature">
				<div class="bg-wrapper case">

					<div class="container">
						<div class="row justify-content-between align-items-center">
							<div class="col-md-8 aos-init aos-animate m-auto text-center" data-aos="fade-right" data-aos-duration="1200">
								<div class="title-style-six">
									<h2 className="font-30 casestudy font-rubik text-white" >Customer Case  <span className="text-warning">Studies</span> for Taskflier.</h2>
								</div>
							</div>

						</div>

						<div class="row justify-content-center mt-35 md-mt-20">
							<div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
								<div class=" text-center mt-40 p-4">
									<img src="/images/case.jpg" alt="" className="case" />
									<p className="text-white font-16 mt-3">"The Platform to bring and manage your dynamic team together & achieve business success."</p>
									<a href="/" class="align-items-center text-center learn-more">
										<span className="text-white font-14 mt-4">Download Now</span>

									</a>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
								<div class=" text-center mt-40 p-4">
									<img src="/images/case.jpg" alt="" className="case" />
									<p className="text-white font-16 mt-3">"The Platform to bring and manage your dynamic team together & achieve business success."</p>
									<a href="/" class="align-items-center text-center learn-more">
										<span className="text-white font-14 mt-4">Download Now</span>

									</a>
								</div>
							</div>
							<div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
								<div class=" text-center mt-40 p-4">
									<img src="/images/case.jpg" alt="" className="case" />
									<p className="text-white font-16 mt-3">"The Platform to bring and manage your dynamic team together & achieve business success."</p>
									<a href="/" class="align-items-center text-center learn-more">
										<span className="text-white font-14 mt-4">Download Now</span>

									</a>
								</div>
							</div>
						</div>
					</div>
					<img src="/images/shape/137.svg" alt="" class="shapes shape-one" />
				</div>

				<div class="partner-slider-two mt-110 pb-100 md-mt-80">
					<div class="container">

						<div class="row justify-content-between align-items-center">
							<div class="col-md-8 aos-init m-auto text-center aos-animate" data-aos="fade-right" data-aos-duration="1200">
								<div class="title-style-six mb-4">
									<h2 class="font-30 casestudy font-rubik">Trusted by Over  <span>5000+</span> Businesses</h2>
								</div>
							</div>
						</div>
						<div class="partnerSliderTwo row">
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-12.png" alt="" /></div>
							</div>
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-13.png" alt="" /></div>
							</div>
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-14.png" alt="" /></div>
							</div>
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-15.png" alt="" /></div>
							</div>
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-16.png" alt="" /></div>
							</div>
							<div class="item col-md-2">
								<div class="img-meta d-flex align-items-center justify-content-center"><img src="/images/logo/logo-14.png" alt="" /></div>
							</div>

						</div>
					</div>
				</div>
			</div>





			<div class="pricing-section-one pt-120   md-mb-80 bg-white" hidden>

				<div class="pricing-table-area pb-0">

					<div class="container">
						<div class="row">
							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
								<div class="team-member team-block-one mb-20 morcase" >

									<div class="img-meta"><img src="/images/media/img_98.png" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- User Name</div>
										<p className="font-12 subtitle"> Business Development Manager, MNB Soft solution</p>
										<div class="desig font-16 themecolor">"TaskFlier has been a game changer for IT Software agency."</div>

									</div>
								</div>
							</div>
							<div class="col-lg-3 col-sm-4 aos-init aos-animate " data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
								<div class="team-member team-block-one mb-20 morcase" >

									<div class="img-meta"><img src="/images/media/img_99.png" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- User Name</div>
										<p className="font-12 subtitle"> Business Development Manager, MNB Soft solution</p>
										<div class="desig font-16 themecolor">"TaskFlier has been a game changer for IT Software agency."</div>
									</div>
								</div>
							</div>
							<div class="col-lg-3 col-sm-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
								<div class="team-member team-block-one mb-20 morcase" >

									<div class="img-meta"><img src="/images/media/img_100.png" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- User Name</div>
										<p className="font-12 subtitle"> Business Development Manager, MNB Soft solution</p>
										<div class="desig font-16 themecolor">"TaskFlier  has been a game changer for IT Software agency."</div>
									</div>
								</div>
							</div>
							<div class="col-lg-3 col-sm-4 aos-init" data-aos="fade-up" data-aos-duration="1200">
								<div class="team-member team-block-one mb-20 morcase" >

									<div class="img-meta"><img src="/images/media/img_101.png" alt="" /></div>
									<div class="info p-4">
										<div class="name font-14 mt-0">- User Name</div>
										<p className="font-12 subtitle"> Business Development Manager, MNB Soft solution</p>
										<div class="desig font-16 themecolor">"TaskFlier  has been a game changer for IT Software agency."</div>
									</div>
								</div>
							</div>


						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Customers;